import { computed, setProperties } from '@ember/object';
import { TIMEFRAME_UNITS, roundTimeframe, findRoundUnit } from 'cio/utils/round-timeframe-units';

/*
 * Computed property computing and accepting number of seconds, connected with count (e.g. 3) and unit (e.g. day) context object properties
 * i.e. 2 minutes: timeframeCount = 2, timeframeUnit = 'minute', timeframe = 120 (2 * 60 seconds)
 */
export default function timeframeComputed({
  countProperty = 'timeframeCount',
  unitProperty = 'timeframeUnit',
  units = TIMEFRAME_UNITS,
  defaultUnitWhenZero = null,
}: {
  countProperty: string;
  unitProperty: string;
  units?: { value: string; seconds: number }[];
  defaultUnitWhenZero?: string | null;
}) {
  return computed(countProperty, unitProperty, {
    get() {
      let countValue = this[countProperty];
      let unitValue = this[unitProperty];
      let unit = units.findBy('value', unitValue);

      if (unit == null) {
        return countValue;
      }

      let { seconds } = unit;
      return countValue * seconds;
    },

    set(_key, value: number) {
      let seconds = roundTimeframe(value);
      let unit = findRoundUnit(seconds, units);

      if (seconds === 0 && defaultUnitWhenZero != null) {
        let defaultUnit = units.findBy('value', defaultUnitWhenZero);
        if (defaultUnit != null) {
          unit = defaultUnit;
        }
      }

      let count = Math.ceil(seconds / unit.seconds);

      setProperties(this, {
        [countProperty]: count,
        [unitProperty]: unit.value,
      });

      return count * unit.seconds;
    },
  });
}
